import CommonFooter from "@/components/commonFooter/index.vue";
import CommonHeader from "@/components/commonHeader/index.vue";
import { purchasePlanApi, uploadPurchaseMaterialUrl } from "@/api/commonApi";
import { ref, onMounted, reactive } from "vue";
import { ElMessage, ElLoading } from "element-plus";
import { SUCCEED_CODE } from "@/constants";
import { useRouter } from "vue-router";
import QrCodeModalContent from "@/components/qrCodeModal/index.vue";

export default {
  name: "editPurchasePlan",
  components: { CommonFooter, CommonHeader, QrCodeModalContent },
  setup() {
    const route = useRouter();
    const newPurchasePlan = ref({
      planName: "",
      planNo: "",
      cityCode: "",
      provinceCode: "",
      citySelect: {},
      address: "",
      categorySelect: "",
      remarks: "",
    });

    const areaDic = ref([]);
    const categoryDic = ref([]);
    const categoryRef = ref(null);
    const tableData = ref([]);
    const newMaterial = ref({
      id: null,
      m2PurchasePlanId: "",
      materialDesc: "",
      materialName: "",
      purchaseCount: "",
      spec: "",
      unit: "",
      edit: true,
    });
    const materialFormRef = ref(null);
    const formRule = ref({
      materialName: [
        {
          required: true,
          message: "请填写材料名称！",
          trigger: "blur",
        },
      ],
      spec: [
        {
          required: true,
          message: "请填写规格型号！",
          trigger: "blur",
        },
      ],
      purchaseCount: [
        {
          required: true,
          message: "请填写计划采购数量！",
          trigger: "blur",
        },
      ],
      unit: [
        {
          required: true,
          message: "请填写材料名称！",
          trigger: "blur",
        },
      ],
    });
    const editing = ref(false);

    const purchasePlanId = ref("");

    const pruchasePlanEditDisable = ref(false);

    const downloadFileUrl =
      "https://m2-joint-procurement.obs.cn-north-1.myhuaweicloud.com/template/%E5%B9%B3%E6%96%B9%E7%BD%91%E9%87%87%E8%B4%AD%E8%AE%A1%E5%88%92%E4%B8%8B%E8%BD%BD%E6%9D%90%E6%96%99%E6%B8%85%E5%8D%95%E6%A8%A1%E6%9D%BF.xlsx";

    const pruchasePlanRules = reactive({
      planName: [
        { required: true, message: "请输入计划名称！", trigger: "blur" },
      ],
      citySelect: [
        { required: true, message: "请选择城市！", trigger: "change" },
      ],
      address: [
        { required: true, message: "请填写详细地址！", trigger: "blur" },
      ],
      categorySelect: [
        { required: true, message: "请选择材料类型！", trigger: "blur" },
      ],
    });

    const purchasePlanRef = ref(null);

    const planStatusDic = [
      {
        value: "123",
        label: "123",
      },
      {
        value: "13",
        label: "13",
      },
    ];

    const qrCodeVisible = ref(false);

    onMounted(() => {
      if (route.currentRoute.value.query.id) {
        purchasePlanId.value = route.currentRoute.value.query.id;
        getPlanDetail();
      } else {
        savePurchasePlan();
      }
      regionList();
      getCategoryList();
    });

    // 地区字典
    const regionList = () => {
      purchasePlanApi.regionList().then((res) => {
        const { data, message, statusCode } = res;
        if (statusCode === SUCCEED_CODE) {
          areaDic.value = data.map((item) => {
            return {
              label: item.provinceName,
              value: item.provinceCode,
              children: item.cityList.map((city) => {
                return {
                  label: city.cityName,
                  value: city.cityCode,
                };
              }),
            };
          });
        } else {
          if (statusCode === 401) {
            route.push({ path: "/" });
          }
          ElMessage.error(message || "获取列表失败！");
        }
      });
    };

    // 选择城市
    const changeCity = (e) => {
      if (e) {
        newPurchasePlan.value.cityCode = e[1];
        newPurchasePlan.value.provinceCode = e[0];
      } else {
        newPurchasePlan.value.cityCode = "";
        newPurchasePlan.value.provinceCode = "";
      }
    };

    // 选择类别
    const changeCategory = (category) => {
      if (category) {
        const categoryLabel = categoryRef.value.getCheckedNodes()[0].pathLabels;
        newPurchasePlan.value.fCategoryId = category[0];
        newPurchasePlan.value.fCategoryName = categoryLabel[0];
        newPurchasePlan.value.sCategoryId = category[1];
        newPurchasePlan.value.sCategoryName = categoryLabel[1];
        newPurchasePlan.value.tCategoryId = category[2];
        newPurchasePlan.value.tCategoryName = categoryLabel[2];
      } else {
        newPurchasePlan.value.fCategoryId = "";
        newPurchasePlan.value.fCategoryName = "";
        newPurchasePlan.value.sCategoryId = "";
        newPurchasePlan.value.sCategoryName = "";
        newPurchasePlan.value.tCategoryId = "";
        newPurchasePlan.value.tCategoryName = "";
      }
    };

    // 计划详情
    const getPlanDetail = () => {
      const loadingInstance = ElLoading.service({ fullscreen: true });
      purchasePlanApi
        .getPlanDetail({ id: purchasePlanId.value })
        .then((res) => {
          loadingInstance.close();
          const { data, message, statusCode } = res;
          if (statusCode === SUCCEED_CODE) {
            if (data) {
              newPurchasePlan.value = data;
              newPurchasePlan.value.citySelect = data.cityCode;
              purchasePlanId.value = data.id;
              newPurchasePlan.value.categorySelect = [
                data.fCategoryId,
                data.sCategoryId,
                data.tCategoryId,
              ];
              pruchasePlanEditDisable.value = data.planStatus !== 0;
              getMaterialList();
            }
          } else {
            ElMessage.error(message || "获取列表失败！");
          }
        });
    };

    // 查询类别列表
    const getCategoryList = () => {
      purchasePlanApi.categoryList().then((res) => {
        const { data, message, statusCode } = res;
        if (statusCode === SUCCEED_CODE) {
          if (data.length) {
            categoryDic.value = data;
          }
        } else {
          ElMessage.error(message || "获取列表失败！");
        }
      });
    };

    //
    const submitPurchasePlan = async (formEl) => {
      if (!formEl) return;
      await formEl.validate((valid) => {
        if (valid) {
          saveOrUpdatePurchasePlan();
        } else {
          ElMessage.error("请检查必填项！");
        }
      });
    };

    // 查询我的采购材料列表
    const getMaterialList = () => {
      purchasePlanApi
        .getMaterialList({ m2PurchasePlanId: purchasePlanId.value })
        .then((res) => {
          const { data, message, statusCode } = res;
          if (statusCode === SUCCEED_CODE) {
            if (data.length) {
              tableData.value = data;
            } else {
              tableData.value = [];
            }
          } else {
            ElMessage.error(message || "获取列表失败！");
          }
        });
    };

    // 新增采购计划材料
    const saveM2MaterialDetails = () => {
      materialFormRef.value.validate((valid) => {
        if (valid) {
          newMaterial.value.m2PurchasePlanId = purchasePlanId.value;
          purchasePlanApi
            .saveM2MaterialDetails(newMaterial.value)
            .then((res) => {
              const { message, statusCode } = res;
              if (statusCode === SUCCEED_CODE) {
                ElMessage.success(message || "操作成功！");
                getMaterialList();
                editing.value = false;
                newMaterial.value = {
                  id: null,
                  m2PurchasePlanId: "",
                  materialDesc: "",
                  materialName: "",
                  purchaseCount: "",
                  spec: "",
                  unit: "",
                  edit: true,
                };
              } else {
                ElMessage.error(message || "操作失败！");
              }
            });
        } else {
          ElMessage.error("请填写必填项！");
        }
      });
    };

    // 新增材料
    const addTableLine = (scope) => {
      editing.value = true;
      if (typeof scope?.$index === "number") {
        tableData.value[scope.$index].edit = true;
        Object.assign(newMaterial.value, scope.row);
      } else {
        tableData.value.unshift(newMaterial.value);
      }
    };

    // 取消添加行
    const cancelAddLine = (index) => {
      if (index === 0 && !tableData.value[index].id) {
        tableData.value.splice(index, 1);
      } else {
        tableData.value[index].edit = false;
      }
      editing.value = false;
      newMaterial.value = {
        id: null,
        m2PurchasePlanId: "",
        materialDesc: "",
        materialName: "",
        purchaseCount: "",
        spec: "",
        unit: "",
        edit: true,
      };
    };

    //
    const handleDownloadFile = () => {
      window.open(downloadFileUrl, "_blank");
    };

    //
    const beforeRemove = () => {};

    // 新增/编辑我的采购计划
    const saveOrUpdatePurchasePlan = () => {
      purchasePlanApi
        .saveOrUpdatePurchasePlan(newPurchasePlan.value)
        .then((res) => {
          const { message, statusCode } = res;
          if (statusCode === SUCCEED_CODE) {
            qrCodeVisible.value = true;
          } else {
            ElMessage.error(message || "操作失败！");
          }
        });
    };

    // 返回列表
    const backToPlanList = () => {
      route.push({ path: "/purchasePlanList" });
    };

    // 关闭二维码弹窗
    const closeQrcodeDialog = () => {
      qrCodeVisible.value = false;
      backToPlanList();
    };

    // 删除材料
    const deleteM2MaterialDetails = (id) => {
      purchasePlanApi.deleteM2MaterialDetails({ id: id }).then((res) => {
        const { message, statusCode } = res;
        if (statusCode === SUCCEED_CODE) {
          ElMessage.success(message || "操作成功！");
          getMaterialList();
        } else {
          ElMessage.error(message || "操作失败！");
        }
      });
    };

    // 初始化采购计划编号和id
    const savePurchasePlan = () => {
      purchasePlanApi.savePurchasePlan().then((res) => {
        const { data, message, statusCode } = res;
        if (statusCode === SUCCEED_CODE) {
          purchasePlanId.value = data.id;
          newPurchasePlan.value.id = data.id;
          newPurchasePlan.value.planNo = data.planNo;
        } else {
          ElMessage.error(message || "初始化失败！");
        }
      });
    };

    return {
      newPurchasePlan,
      planStatusDic,
      pruchasePlanRules,
      areaDic,
      categoryDic,
      categoryRef,
      tableData,
      newMaterial,
      uploadPurchaseMaterialUrl,
      editing,
      purchasePlanId,
      purchasePlanRef,
      qrCodeVisible,
      pruchasePlanEditDisable,
      materialFormRef,
      formRule,
      regionList,
      changeCity,
      changeCategory,
      getMaterialList,
      saveM2MaterialDetails,
      addTableLine,
      cancelAddLine,
      handleDownloadFile,
      beforeRemove,
      saveOrUpdatePurchasePlan,
      backToPlanList,
      submitPurchasePlan,
      deleteM2MaterialDetails,
      closeQrcodeDialog,
    };
  },
};
